import { createComponent } from '../../Foundation';
import { TextView } from './Text.view';
import { TextStyles as styles } from './Text.styles';
export var Text = createComponent(TextView, {
    displayName: 'Text',
    styles: styles,
});
export default Text;
//# sourceMappingURL=Text.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/office-ui-fabric-react/lib/components/Text/Text.js
// module id = 947
// module chunks = 0